import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

export const MapToastsContainer = styled.div`
	position: absolute;
	z-index: 1000;
	/* border: 1px solid red; */
	bottom: 6.5rem;
	/* padding: 0.5rem; */
	width: 100%;
	color: #fff;
	/* height: 100px; */
`;

export const SingleMapToastContainer = styled.div`
	padding: 0.5rem;
`;

export const MapToastsSwiperContainer = styled.div`
	position: relative;
`;

export const MapToastsCount = styled.div`
	position: absolute;
	top: -8px;
	left: 0.5rem;
	transform: translateY(-100%);
	width: 44px;
	height: 24px;
	background: #FF8F1C;//var(--ion-color-secondary);
	border-radius: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid var(--ion-color-secondary-tint);
	p {
		font-size: 12px;
		color: var(--ion-color-light-shade);
		line-height: 1;
	}
`;

export const PlacesNearbyButton = styled.div`
	position: absolute;
	top: -8px;
	right: 0.5rem;
	transform: translateY(-100%);
	width: 34px;
	height: 34px;
	border: 2px solid var(--ion-color-light-tint);
	border-radius: 50%;
	background: #FF8F1C;//var(--ion-color-secondary);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const MapToastsSwiper = styled(Swiper)`
	padding: 0.5rem;
`;

export const MapToastsSwiperSlide = styled(SwiperSlide)`
	width: 75% !important;
`;
